// Module
var code = "<template><require from=\"../../components/notifications/notification\"></require><router-view></router-view><notification></notification></template>";
// Exports
module.exports = code;